import { dataUploadDesktopSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUploadDesktopSolid = /*#__PURE__*/createIcon(dataUploadDesktopSolid)
export default IconUploadDesktopSolid
